import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import { AppState } from '../../core/core.module';

import { personasReducer } from './../persona/entity-personas/entity-personas.reducer';
import { paisesReducer } from './../ubicaciones/entity-paises/entity-paises.reducer';
import { direccionesGeograficaIDEReducer } from '../ubicaciones/entity-direcciones-geografica-ide/entity-direcciones-geografica-ide.reducer';

import { EntityPersonasState } from './../persona/entity-personas/entity-personas.state';
import { EntityPaisesState } from '../ubicaciones/entity-paises/entity-paises.state';
import { EntityDireccionesGeograficaIDEState } from '../ubicaciones/entity-direcciones-geografica-ide/entity-direcciones-geografica-ide.state';
import { localidadesReducer } from '../ubicaciones/entity-localidades/entity-localidades.reducer';
import { EntityLocalidadesState } from '../ubicaciones/entity-localidades/entity-localidades.state';
import { departamentosReducer } from '../ubicaciones/entity-departamentos/entity-departamentos.reducer';
import { EntityDepartamentosState } from '../ubicaciones/entity-departamentos/entity-departamentos.state';

import { EntityTecnicoResponsableState } from '../roles/entity-tecnico-responsable/entity-tecnico-responsable.state';
import { EntityMuestreadorState } from '../roles/entity-muestreador/entity-muestreador.state';
import { tecnicoResponsableReducer } from '../roles/entity-tecnico-responsable/entity-tecnico-responsable.reducer';
import { muestreadorReducer } from '../roles/entity-muestreador/entity-muestreador.reducer';
import { rolReducer } from '../roles/entity-roles/entity-roles.reducer';
import { EntityRolState } from '../roles/entity-roles/entity-roles.state';
import { personasFisicaReducer } from '../empresas/entity-personas-fisica/entity-personas-fisica.reducer';
import { EntityPersonasFisicaState } from '../empresas/entity-personas-fisica/entity-personas-fisica.state';
import { EntityPersonasJuridicaState } from '../empresas/entity-personas-juridica/entity-personas-juridica.state';
import { personasJuridicaReducer } from '../empresas/entity-personas-juridica/entity-personas-juridica.reducer';

import { entidadesProductivaReducer } from '../empresas/entity-entidad-productiva/entity-entidades-productiva.reducer';

import { EntityEntidadesProductivaState } from '../empresas/entity-entidad-productiva/entity-entidades-productiva.state';

import { EntityTecnicosState } from '../roles/entity-tecnicos/entity-tecnicos.state';

import { tecnicosReducer } from '../roles/entity-tecnicos/entity-tecnicos.reducer';

import { EntityNaturalezaJuridicaState } from '../empresas/entity-naturalezas-juridica/entity-naturalezas-juridica.state';
import { naturalezasJuridicaReducer } from '../empresas/entity-naturalezas-juridica/entity-naturalezas-juridica.reducer';

import { EntityCurrentEmpresaState } from '../empresas/entity-mis-empresas/entity-current-empresa.state';
import { currentEmpresaReducer } from '../empresas/entity-mis-empresas/entity-current-empresa.reducer';

import { EntityDepositosState } from '../actividades/entity-depositos/depositos.state';

// actividades
import { depositosReducer } from '../actividades/entity-depositos/depositos.reducer';
import { laboratoriosReducer } from '../actividades/entity-laboratorios/laboratorios.reducer';
import { EntityLaboratoriosState } from '../actividades/entity-laboratorios/laboratorios.state';
import { EntityPaisesDocumentoState } from '../ubicaciones/entity-paises-documento/paises-documento.state';
import { paisesDocumentoReducer } from '../ubicaciones/entity-paises-documento/paises-documento.reducer';
import { EntityStepperState } from '../actividades/entity-stepper/stepper.state';
import { stepperReducer } from '../actividades/entity-stepper/stepper.reducer';
import { EntityComercializacionesState } from '../actividades/entity-comercializaciones/comercializaciones.state';
import { comercializacionesReducer } from '../actividades/entity-comercializaciones/comercializaciones.reducer';
import { rpeSubActividadesReducer } from '../actividades/entity-rpe-sub-actividades/rpe-sub-actividades.reducer';
import { EntityRPESubActividadesState } from '../actividades/entity-rpe-sub-actividades/rpe-sub-actividades.state';
import { actividadesGrupoEspecieReducer } from '../actividades/entity-actividades-grupo-especie/entity-actividades-grupo-especie.reducer';
import { EntityActividadesGrupoEspecieState } from '../actividades/entity-actividades-grupo-especie/entity-actividades-grupo-especie.state';
import { actividadesReducer } from '../actividades/entity-actividades/entity-actividades.reducer';
import { EntityActividadesState } from '../actividades/entity-actividades/entity-actividades.state';
import { entidadesProductivaActividadReducer } from '../actividades/entity-entidades-productiva-actividad/entity-entidades-productiva-actividad.reducer';
import { EntityEntidadesProductivaActividadState } from '../actividades/entity-entidades-productiva-actividad/entity-entidades-productiva-actividad.state';
import { tiposActividadReducer } from '../actividades/entity-tipos-actividad/entity-tipos-actividad.reducer';
import { EntityTiposActividadState } from '../actividades/entity-tipos-actividad/entity-tipos-actividad.state';
import { tiposDocumentoReducer } from '../persona/entity-tipos-documento/entity-tipos-documento.reducer';
import { EntityTiposDocumentoState } from '../persona/entity-tipos-documento/entity-tipos-documento.state';
import { tiposTecnicoReducer } from '../persona/entity-tipos-tecnico/entity-tipos-tecnico.reducer';
import { EntityTiposTecnicoState } from '../persona/entity-tipos-tecnico/entity-tipos-tecnico.state';
import { integranteReducer } from '../roles/entity-integrante/entity-integrante.reducer';
import { EntityIntegranteState } from '../roles/entity-integrante/entity-integrante.state';
import { rolesActividadReducer } from '../roles/entity-roles-actividad/entity-roles-actividad.reducer';
import { EntityRolesActividadState } from '../roles/entity-roles-actividad/entity-roles-actividad.state';
import { RPERolActividadesReducer } from '../roles/entity-rpe-rol-actividades/entity-roles-actividad.reducer';
import { EntityRPERolActividadesState } from '../roles/entity-rpe-rol-actividades/entity-rpe-rol-actividades.state';
import { tiposRolReducer } from '../roles/entity-tipos-rol/entity-tipos-rol.reducer';
import { EntityTiposRolState } from '../roles/entity-tipos-rol/entity-tipos-rol.state';
import { EntityDireccionesGeograficaIDEExactaState } from '../ubicaciones/entity-direcciones-geografica-ide-exacta/entity-direcciones-geografica-ide.state';
import { direccionesGeograficaIDEExactaReducer } from '../ubicaciones/entity-direcciones-geografica-ide-exacta/entity-direcciones-geografica-ide.reducer';
import { EntitySitiosProcesamientoState } from '../actividades/entity-sitios-procesamiento/sitios-procesamiento.state';
import { sitiosProcesamientoReducer } from '../actividades/entity-sitios-procesamiento/sitios-procesamiento.reducer';
import { EntityViverosGrupoEspecieState } from '../actividades/entity-viveros-grupo-especie/entity-viveros-grupo-especie.state';
import { viverosGrupoEspecieReducer } from '../actividades/entity-viveros-grupo-especie/entity-viveros-grupo-especie.reducer';
import { tramiteReducer } from '../tramites/tramite.reducer';
import { TramiteState } from '../tramites/tramite.state';
import { tipoEquipamientoLaboratorioReducer } from '../actividades/entity-tipos-equipamiento-laboratorio/entity-tipos-equipamiento-laboratorio.reducer';
import { EntityTipoEquipamientoLaboratorioState } from '../actividades/entity-tipos-equipamiento-laboratorio/entity-tipos-equipamiento-laboratorio.state';
import { maquinaMovilReducer } from '../actividades/entity-maquinas-moviles/entity-maquinas-moviles.reducer';
import { EntityMaquinaMovilState } from '../actividades/entity-maquinas-moviles/entity-maquinas-moviles.state';
import { EntityLocalidadesIDEState } from '../ubicaciones/entity-localidades-ide/entity-localidades-ide.state';
import { localidadesIDEReducer } from '../ubicaciones/entity-localidades-ide/entity-localidades-ide.reducer';
import { entitySexoReducer } from '../persona/entity-sexo/entity-sexo.reducer';
import { EntitySexoState } from '../persona/entity-sexo/entity-sexo.state';
import { EntityUserState } from '../persona/entity-usuarios/entity-usuario.state';
import { entityUserReducer } from '../persona/entity-usuarios/entity-user.reducer';
import { EntityTramiteStatusState } from '../tramites/tramite-status/tramite-status.state';
import { tramiteStatusReducer } from '../tramites/tramite-status/tramite-status.reducer';
import { EntityEstadosRolState } from '../roles/entity-estado-rol/entity-estados-rol.state';
import { entityEstadosRolReducer } from '../roles/entity-estado-rol/entity-estados-rol.reducer';
import { EntityEstadosLaboratorioState } from '../actividades/entity-estados-laboratorio/estados-laboratorio.state';
import { entityEstadosLaboratorioReducer } from '../actividades/entity-estados-laboratorio/estados-laboratorio.reducer';
import { MovimientoTramiteState } from '../tramites/movimiento-tramite/movimiento-tramite.state';
import { movimientoTramiteReducer } from '../tramites/movimiento-tramite/movimiento-tramite.reducer';
import { EntityAcreditacionEmpresaState } from '../empresas/acreditacion-empresa/entity-acreditacion-empresa.state';
import { EntityEtapasEmpresaState } from '../empresas/entity-etapas-empresa/entity-etapas-empresa.state';
import { EntityEtapasEmpresaReducer } from '../empresas/entity-etapas-empresa/entity-etapas-empresa.reducer';
import { EntityAcreditacionEmpresaReducer } from '../empresas/acreditacion-empresa/entity-acreditacion-empresa.reducer';
import { EntityEspeciesCertificablesState } from '../actividades/entity-especies-certificables/entity-especies-certificables.state';
import { EntityEspeciesCertificablesReducer } from '../actividades/entity-especies-certificables/entity-especies-certificables.reducer';
import { EntityEmpresaDGIState } from '../empresas/empresas-dgi/empresas-dgi.state';
import { empresaDGIReducer } from '../empresas/empresas-dgi/empresas-dgi.reducer';

export const FEATURE_NAME = 'vistaUsuario';
export const selectVistaUsuario = createFeatureSelector<
  State,
  VistaUsuarioState
>(FEATURE_NAME);

export const reducers: ActionReducerMap<VistaUsuarioState> = {
  actividades: actividadesReducer,
  actividadesGrupoEspecie: actividadesGrupoEspecieReducer,
  viverosGrupoEspecie: viverosGrupoEspecieReducer,
  currentEmpresa: currentEmpresaReducer,
  integrantes: integranteReducer,
  personas: personasReducer,
  tecnicosResponsables: tecnicoResponsableReducer,
  muestreadores: muestreadorReducer,
  naturalezasJuridica: naturalezasJuridicaReducer,
  paises: paisesReducer,
  direccionesGeograficaIDE: direccionesGeograficaIDEReducer,
  direccionesGeograficaIDEExacta: direccionesGeograficaIDEExactaReducer,
  localidades: localidadesReducer,
  localidadesIDE: localidadesIDEReducer,
  departamentos: departamentosReducer,
  tiposDocumento: tiposDocumentoReducer,
  roles: rolReducer,
  personasFisica: personasFisicaReducer,
  personasJuridica: personasJuridicaReducer,
  rolesActividad: rolesActividadReducer,
  tiposActividad: tiposActividadReducer,
  entidadesProductivaActividad: entidadesProductivaActividadReducer,
  entidadesProductiva: entidadesProductivaReducer,
  tiposRol: tiposRolReducer,
  tiposTecnico: tiposTecnicoReducer,
  tecnicos: tecnicosReducer,
  rpeRolActividades: RPERolActividadesReducer,
  paisesDocumento: paisesDocumentoReducer,
  estadosLaboratorio: entityEstadosLaboratorioReducer,
  // actividades
  depositos: depositosReducer,
  laboratorios: laboratoriosReducer,
  sitiosProcesamiento: sitiosProcesamientoReducer,
  tipoEquipamientoLaboratorio: tipoEquipamientoLaboratorioReducer,
  stepperActividad: stepperReducer,
  comercializaciones: comercializacionesReducer,
  rpeSubActividades: rpeSubActividadesReducer,
  tramites: tramiteReducer,
  maquinaMovil: maquinaMovilReducer,
  sexo: entitySexoReducer,
  user: entityUserReducer,
  tramiteStatus: tramiteStatusReducer,
  estadosRol: entityEstadosRolReducer,
  movimientoTramite: movimientoTramiteReducer,
  etapasEmpresa: EntityEtapasEmpresaReducer,
  acreditacionEmpresa: EntityAcreditacionEmpresaReducer,
  especiesCertificables: EntityEspeciesCertificablesReducer,
  empresaDGI: empresaDGIReducer,
};

export interface VistaUsuarioState {
  user: EntityUserState
  estadosRol: EntityEstadosRolState
  actividades: EntityActividadesState;
  actividadesGrupoEspecie: EntityActividadesGrupoEspecieState;
  viverosGrupoEspecie: EntityViverosGrupoEspecieState;
  currentEmpresa: EntityCurrentEmpresaState;
  departamentos: EntityDepartamentosState;
  direccionesGeograficaIDE: EntityDireccionesGeograficaIDEState;
  direccionesGeograficaIDEExacta: EntityDireccionesGeograficaIDEExactaState;
  entidadesProductivaActividad: EntityEntidadesProductivaActividadState;
  entidadesProductiva: EntityEntidadesProductivaState;
  integrantes: EntityIntegranteState;
  sexo: EntitySexoState;
  localidades: EntityLocalidadesState;
  localidadesIDE: EntityLocalidadesIDEState;
  muestreadores: EntityMuestreadorState;
  naturalezasJuridica: EntityNaturalezaJuridicaState;
  paises: EntityPaisesState;
  personas: EntityPersonasState;
  personasFisica: EntityPersonasFisicaState;
  personasJuridica: EntityPersonasJuridicaState;
  roles: EntityRolState;
  rolesActividad: EntityRolesActividadState;
  tecnicos: EntityTecnicosState;
  tecnicosResponsables: EntityTecnicoResponsableState;
  tiposActividad: EntityTiposActividadState;
  tiposDocumento: EntityTiposDocumentoState;
  tiposRol: EntityTiposRolState;
  tiposTecnico: EntityTiposTecnicoState;
  rpeRolActividades: EntityRPERolActividadesState;
  paisesDocumento: EntityPaisesDocumentoState;
  estadosLaboratorio: EntityEstadosLaboratorioState;
  acreditacionEmpresa: EntityAcreditacionEmpresaState
  etapasEmpresa: EntityEtapasEmpresaState

  // actividades
  depositos: EntityDepositosState;
  laboratorios: EntityLaboratoriosState;
  sitiosProcesamiento: EntitySitiosProcesamientoState;
  tipoEquipamientoLaboratorio: EntityTipoEquipamientoLaboratorioState;
  stepperActividad: EntityStepperState;
  comercializaciones: EntityComercializacionesState;
  rpeSubActividades: EntityRPESubActividadesState;
  maquinaMovil: EntityMaquinaMovilState;
  especiesCertificables: EntityEspeciesCertificablesState;

  //tramites
  tramites: TramiteState;
  tramiteStatus: EntityTramiteStatusState
  movimientoTramite: MovimientoTramiteState
  empresaDGI: EntityEmpresaDGIState;
}

export interface State extends AppState {
  vistaUsuario: VistaUsuarioState;
}
